import { render, staticRenderFns } from "./TypicalRoot.vue?vue&type=template&id=6900921c&lang=pug&"
import script from "./TypicalRoot.vue?vue&type=script&lang=js&"
export * from "./TypicalRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports